import React from 'react';
import {Link} from 'react-router-dom'
import logo from './ISB-Dash.png'
import './AppHeader.css';

class AppHeader extends React.Component {
  constructor(props) {
    super(props);
    this.handleLogout = this.handleLogout.bind(this);
  }

  handleLogout(event) {
      window.localStorage.removeItem('token');
      this.props.setToken();
      event.preventDefault();
  }


  render() {
    let module = '';
    switch (this.props.location.pathname.slice(-3)) {
        case "eal":
            module = 'eal';
            break;
        case "lrc":
            module = 'lrc';
            break;
        case "map":
            module = 'map';
            break;
        case "/es":
            module = 'es';
            break;
        case "ata":
            module = 'counselor-data';
            break;
        case "nts":
            if (this.props.location.pathname.slice(-8) === 'comments') { module = 'comments'; }
            if (this.props.location.pathname.slice(-9) === 'documents') { module = 'documents'; }
            break;
        case "ile":
            module = 'language-profile';
            break;
        case "sat":
            if (this.props.location.pathname.slice(-4) === 'psat') { module = 'psat'; }
            if (this.props.location.pathname.slice(-4) === '/sat') { module = 'sat'; }
            break;
        case "erb":
            module = 'erb';
            break;
        case "cem":
            module = 'cem';
            break;
        case "bdp":
            module = 'ibdp';
            break;
        case "ing":
            module = 'grading';
            break;
        default:
            module = '';
    }; 

    //const module = this.props.location.pathname.endsWith('eal') ? 'eal' : '';
    return (
        <header className="AppHeader">
          <Link to="/dashboard">
            <div className="app-logo-container">
              {<img src={logo} className="app-logo" alt="logo" />}
            </div>
            <h2>ISB Dashboard</h2>
          </Link>
          <ul className="app-header-menu">
            <li><Link to="/dashboard">Dashboard</Link></li>
            <li><Link to={module ? "/students/" + module : "/students"}>Students</Link></li>
            <li className="logout"><a onClick={this.handleLogout} >Logout <i className="fa fa-sign-out"></i></a></li>
            <li className="user">
              <i className="fa fa-user-circle-o"></i> <span>Hello,</span> {this.props.user.cn} <i className="fa fa-caret-down"></i>
            </li>
          </ul>
        </header>
    );
  }
}

export default AppHeader;



// WEBPACK FOOTER //
// ./src/AppHeader.js